import _regeneratorRuntime from "/builds/adn/dashboard-vuejs/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _objectSpread from "/builds/adn/dashboard-vuejs/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _createForOfIteratorHelper from "/builds/adn/dashboard-vuejs/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _asyncToGenerator from "/builds/adn/dashboard-vuejs/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import router from './router';
import store from './store';
import { Message } from 'element-ui';
import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css'; // progress bar style
import { getToken } from '@/utils/auth'; // get token from cookie
import getPageTitle from '@/utils/get-page-title';
NProgress.configure({
  showSpinner: false
}); // NProgress Configuration

var whiteList = ['/login', '/auth-redirect']; // no redirect whitelist

router.beforeEach(/*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(to, from, next) {
    var hasToken, hasRoles, _yield$store$dispatch, roles, accessRoutes, _iterator, _step, accessRoute;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          // start progress bar
          NProgress.start();

          // set page title
          document.title = getPageTitle(to.meta.title);

          // determine whether the user has logged in
          hasToken = getToken();
          if (!hasToken) {
            _context.next = 33;
            break;
          }
          if (!(to.path === '/login')) {
            _context.next = 9;
            break;
          }
          // if is logged in, redirect to the home page
          next({
            path: '/'
          });
          NProgress.done();
          _context.next = 31;
          break;
        case 9:
          // determine whether the user has obtained his permission roles through getInfoMe
          hasRoles = store.getters.roles && store.getters.roles.length > 0;
          if (!hasRoles) {
            _context.next = 14;
            break;
          }
          next();
          _context.next = 31;
          break;
        case 14:
          _context.prev = 14;
          _context.next = 17;
          return store.dispatch('user/getInfoMe');
        case 17:
          _yield$store$dispatch = _context.sent;
          roles = _yield$store$dispatch.roles;
          _context.next = 21;
          return store.dispatch('permission/generateRoutes', roles);
        case 21:
          accessRoutes = _context.sent;
          // dynamically add accessible routes
          _iterator = _createForOfIteratorHelper(accessRoutes);
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              accessRoute = _step.value;
              router.addRoute(accessRoute);
            }

            // hack method to ensure that addRoutes is complete
            // set the replace: true, so the navigation will not leave a history record
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          next(_objectSpread(_objectSpread({}, to), {}, {
            replace: true
          }));
          _context.next = 31;
          break;
        case 27:
          _context.prev = 27;
          _context.t0 = _context["catch"](14);
          // remove token and go to login page to re-login
          // await store.dispatch('user/resetToken')
          Message.error(_context.t0 || 'Has Error');
          // next(`/login?redirect=${to.path}`)
          NProgress.done();
        case 31:
          _context.next = 34;
          break;
        case 33:
          /* has no token*/

          if (whiteList.indexOf(to.path) !== -1) {
            // in the free login whitelist, go directly
            next();
          } else {
            // other pages that do not have permission to access are redirected to the login page.
            next("/login?redirect=".concat(to.fullPath));
            NProgress.done();
          }
        case 34:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[14, 27]]);
  }));
  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());
router.afterEach(function () {
  // finish progress bar
  NProgress.done();
});